// Penyusunan pasangan searchBy/searchValue halaman Input Surveilans Knowlesi.
// Dipisah jadi fungsi murni supaya urutan pasangan (syarat backend: jumlah
// searchBy harus sama dengan searchValue) bisa diuji tanpa merender halaman.
export const buildSearchParams = (filterState = {}) => {
  const { filter_year, filter_month, filter_sample_type, filter_fasyankes } =
    filterState;

  let searchBy = "lab_checking_type,parasyte";
  let searchValue = "Mikroskop,Probable Knowlesi";

  // Presisi tanggal mengikuti filter yang terisi: tahun saja, bulan saja, atau
  // keduanya (YYYY-MM).
  const searchByDate =
    filter_year && filter_month
      ? "|YYYY-MM"
      : filter_year
      ? "|YYYY"
      : filter_month
      ? "|MM"
      : "";
  const searchValueDate =
    filter_year && filter_month
      ? `,${filter_year}-${filter_month}`
      : filter_year
      ? `,${filter_year}`
      : filter_month
      ? `,${filter_month}`
      : "";

  if (filter_year || filter_month) {
    // sesuaikan field tanggal filter di backend bila perlu
    searchBy += `,patient_visite_date${searchByDate}`;
    searchValue += searchValueDate;
  }

  if (filter_sample_type) {
    searchBy += ",sample_send_type";
    searchValue += `,${filter_sample_type}`;
  }

  // Fasyankes asal kasus; backend memperlakukan field yang memuat "id" sebagai
  // perbandingan "=", dan scope kabupaten user tetap di-AND di sana.
  if (filter_fasyankes) {
    searchBy += ",f.id";
    searchValue += `,${filter_fasyankes}`;
  }

  return { searchBy, searchValue };
};
